import { render } from "./ShowFeatures.vue?vue&type=template&id=446077a6&scoped=true"
import script from "./ShowFeatures.vue?vue&type=script&lang=js"
export * from "./ShowFeatures.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./ShowFeatures.vue?vue&type=style&index=1&id=446077a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446077a6"]])

export default __exports__